import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import LoadMore from '../../../app/components/load-more';
import Loader from '../../../app/components/loader';
import withLayoutProps from '../../hoc/with-layout-props';
import withFeedMetadataSettings from '../../../app/hoc/with-feed-metadata-settings';
import PostListSimple from './post-list-simple';
import PostListMobile from './post-list-mobile';
import PostListItem from '../post-list-item';
import styles from './post-list.scss';
import { getIsPostListFullWidthEnabled } from '../../../app/selectors/app-settings-selectors';

const LIST_COMPONENTS = { PostListSimple, PostListMobile };
const ITEM_COMPONENTS = { PostListItem };

const PostList = ({
  layoutConfig,
  layoutName,
  isLoading,
  posts,
  onLikeClick,
  isLayoutTextOnImage,
  borderWidth,
  loadMore,
  hasMorePosts,
  isMetadataFooterVisible,
  isPostListFullWidthEnabled,
}) => {
  const containerClassName = classNames(
    styles.container,
    styles[layoutName],
    isPostListFullWidthEnabled && styles.fullWidth,
    !isMetadataFooterVisible && styles.withoutFooter,
    'post-list',
  );
  const { listComponentName, itemComponentName, itemConfig } = layoutConfig;
  const ListComponent = LIST_COMPONENTS[listComponentName];
  const ItemComponent = ITEM_COMPONENTS[itemComponentName];

  const itemProps = {
    layoutName,
    itemConfig,
    isLayoutTextOnImage,
    borderWidth,
    onLikeClick,
  };

  const listProps = {
    posts,
    layoutName,
    ItemComponent,
    itemProps,
    isLoading,
  };

  return (
    <div className={containerClassName}>
      <LoadMore loadMore={loadMore} loader={<Loader />} isLoading={isLoading} hasMore={hasMorePosts}>
        <ListComponent {...listProps} />
      </LoadMore>
    </div>
  );
};

PostList.propTypes = {
  posts: PropTypes.array,
  onLikeClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  layoutName: PropTypes.string.isRequired,
  layoutConfig: PropTypes.object.isRequired,
  isLayoutTextOnImage: PropTypes.bool.isRequired,
  borderWidth: PropTypes.number.isRequired,
  loadMore: PropTypes.func,
  hasMorePosts: PropTypes.bool.isRequired,
  isMetadataFooterVisible: PropTypes.bool,
  isPostListFullWidthEnabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isPostListFullWidthEnabled: getIsPostListFullWidthEnabled(state),
});

export default flowRight(connect(mapStateToProps), withLayoutProps, withFeedMetadataSettings)(PostList);
